import { useState } from 'react';
import UITruncateMultiline from 'UIComponents/text/UITruncateMultiline';
import I18n from 'I18n';
import PropTypes from 'prop-types';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import ColumnLayoutIcon from 'ContentEditorUI/components/shared/ColumnLayoutIcon';
import { DragSource } from 'react-dnd';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import { DRAG_TYPES } from 'ContentEditorUI/utils/DragAndDropConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_CHARS = 23;
const moduleSource = {
  beginDrag(props) {
    const dragPayload = {
      customLayoutKey: props.labelKey,
      type: 'customLayout',
      isColumn: false,
      isRow: true,
      isTopMostRow: true
    };
    props.onDragStart(dragPayload);
    return dragPayload;
  },
  endDrag(props, monitor) {
    const dropResult = monitor.getDropResult();
    const dragItem = monitor.getItem();
    if (!monitor.didDrop()) {
      props.onDragEnd(undefined, dragItem);
      return;
    }
    props.onDragEnd(dropResult, dragItem);
  }
};
const Draggable = DragSource(DRAG_TYPES.CUSTOM_SECTION, moduleSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging()
}));
function InpageDraggableLayout({
  labelKey,
  widths,
  dark,
  iconHeight,
  connectDragSource
}) {
  const [isWiggly, setIsWiggly] = useState(false);
  const toggleWiggleCard = () => {
    setIsWiggly(!isWiggly);
  };
  return connectDragSource( /*#__PURE__*/_jsxs("div", {
    className: isWiggly ? 'wiggly-layout section-flex-grid-tile' : 'section-flex-grid-tile',
    "data-test-id": `layout-section-tile-${labelKey}`,
    "data-hs-dragdrop": true,
    onClick: () => toggleWiggleCard(),
    onAnimationEnd: () => toggleWiggleCard(),
    children: [/*#__PURE__*/_jsx("div", {
      className: "section-flex-grid-tile-icon",
      children: /*#__PURE__*/_jsx(ColumnLayoutIcon, {
        columnWidths: widths,
        dark: dark,
        height: iconHeight
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "section-flex-grid-tile-label",
      children: /*#__PURE__*/_jsx(UITruncateMultiline, {
        maxChars: MAX_CHARS,
        text: I18n.text(`addSectionPanel.columnLayouts.labels.${labelKey}`)
      })
    })]
  }));
}
export default Draggable(InpageDraggableLayout);
InpageDraggableLayout.propTypes = {
  labelKey: PropTypes.string.isRequired,
  widths: PropTypes.array.isRequired,
  dark: PropTypes.bool.isRequired,
  iconHeight: PropTypes.number.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  onDragStart: PropTypes.func.isRequired,
  closePatagoniaSidebar: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired
};